// export const SERVER_URL = "http://anyrace.local/index.php";
export const SERVER_URL = location.protocol + "//" + location.host;

export const isInViewport = (box) => {
    const rect = box.getBoundingClientRect();
    /* 
    I have removed the following condition so the function will 
    return even if the product is half visible from the bottom
    rect.top >= 0 && 
     */
    console.log("isInViewport", rect);
    return rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth);
  }